module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号",
      "prop": "num",
      "rules": [{
        required: true,
        message: '请输入证件号',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交认证\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c1b4795","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertPersonApplyOther.vue
// module id = 1551
// module chunks = 0